import { Api } from 'src/core/decorators/dto/api.decorator';
import { GenAIPromptTemplateDto } from './gen-ai-prompt-template.dto';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/query/prompt-templates')
export class GenAIPromptTemplateListDto extends DtoHasApi {
  templates: GenAIPromptTemplateDto[];
}
